import { useLocation } from 'react-router-dom';

import LayoutStandard from '@/components/LayoutStandard';
import usePageHeight from '@/hooks/usePageHeight';

import LoginForm from '../components/LoginPage/LoginForm';

function LoginPage() {
  const pageHeight = usePageHeight();
  const location = useLocation();
  const activationKey = location.state?.activationKey;

  return (
    <LayoutStandard
      heading="Sign in to your Tapt account"
      backgroundColor="bg-gray-50"
    >
      <div
        className="sm:mx-auto sm:w-full sm:max-w-md lg:max-w-lg min-h-[50vh]"
        style={{ maxHeight: pageHeight }}
      >
        {/* EMAIL FIRST FLOW - DESKTOP */}
        <div className="bg-white py-2 px-4 sm:rounded-lg sm:px-10 sm:py-8 lg:border lg:border-gray-100">
          <LoginForm />
        </div>
      </div>
    </LayoutStandard>
  );
}

export default LoginPage;
